module.exports = __webpack_public_path__ + "static/media/adicionaColabradorRegister.bbe62541.jpg";